import { Card, Chip, Stack, ThemeProvider } from "@mui/material";
import ModalConfirm from "components/modal/ModalConfirm";
import Table from "components/table/Table";
import { ALL_OPTION } from "constant";
import { useModalState } from "hooks/useModalState";
import { usePagination } from "hooks/usePagination";
import { useMemo, useState } from "react";
import {
  useDeleteQueue,
  useGetCountListQueue,
  useGetListQueue,
} from "service/query/queue.query";
import muiTheme from "theme/muiTheme";

import QueueFilter from "./components/QueueFilter";
import QueueModal from "./components/QueueModal";

const Queue = () => {
  const {
    page,
    pageSize,
    limit,
    skip,
    handleChangePage,
    handleChangePageSize,
  } = usePagination();
  const [where, setWhere] = useState();
  const [currentItem, setCurrentItem] = useState(null);
  const updateQueueModal = useModalState();
  const deleteQueueModal = useModalState();
  const deleteQueueQuery = useDeleteQueue(currentItem?.id);

  const { data: listQueue, isFetching } = useGetListQueue(
    {
      filter: {
        order: "createdAt DESC",
        limit,
        skip,
        where,
      },
    },
    { placeholderData: (prev) => prev }
  );

  const { data: count } = useGetCountListQueue({ where });

  const columns = useMemo(
    () => [
      {
        id: "code",
        name: "Mã hàng đợi",
      },
      {
        id: "province_name",
        name: "Bộ phận",
      },
      { id: "name", name: "Tên hàng đợi" },
      {
        id: "listExtension",
        name: "Máy lẻ",
        render: (record) =>
          record.members && (
            <Stack direction="row" spacing={0.5}>
              {record.members.map((item) => (
                <Chip label={item.name} key={item.id} />
              ))}
            </Stack>
          ),
      },
      {
        id: "note",
        name: "Ghi chú",
      },
      {
        id: "createdAt",
        name: "Thời gian tạo",
        type: "datetime",
      },
      {
        id: "lastUpdate",
        name: "Thời gian cập nhật",
        type: "datetime",
      },
    ],
    []
  );

  const handleOpenModalCreate = () => {
    setCurrentItem(null);
    updateQueueModal.openModal();
  };

  const handleOpenModalEdit = (record) => {
    setCurrentItem(record);
    updateQueueModal.openModal();
  };

  const handleOpenModalDelete = (record) => {
    setCurrentItem(record);
    deleteQueueModal.openModal();
  };

  const handleCloseUpdateQueueModal = () => {
    setCurrentItem(null);
    updateQueueModal.closeModal();
  };

  const handleCloseModalDelete = () => {
    setCurrentItem(null);
    deleteQueueModal.closeModal();
  };

  const handleSearchQueue = ({ name, subOrg, code }) => {
    setWhere({
      ...(name && { name: { like: name } }),
      ...(code && { code: { like: code, options: "i" } }),
      ...(subOrg !== ALL_OPTION.value && { subOrg }),
    });
    handleChangePage(1);
  };

  const handleDeleteQueue = () => {
    deleteQueueQuery.mutate(null, {
      onSuccess: handleCloseModalDelete,
    });
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ p: 2 }}>
        <QueueFilter onSubmit={handleSearchQueue} />
      </Card>

      <Card sx={{ mt: 2 }}>
        <Table
          columns={columns}
          data={listQueue}
          showHoverRow
          actionColumn={{
            onDelete: handleOpenModalDelete,
            onEdit: handleOpenModalEdit,
          }}
          toolbar={{
            title: "Danh sách hàng đợi",
            onCreate: handleOpenModalCreate,
          }}
          pagination={{
            page,
            pageSize,
            totalItems: count,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
          loading={isFetching}
        />
      </Card>

      {updateQueueModal.open && (
        <QueueModal
          open={updateQueueModal.open}
          onClose={handleCloseUpdateQueueModal}
          currentItem={currentItem}
        />
      )}

      <ModalConfirm
        onClose={deleteQueueModal.closeModal}
        open={deleteQueueModal.open}
        onConfirm={handleDeleteQueue}
        loading={deleteQueueQuery.isPending}
        title="Bạn có muốn xóa hàng đợi?"
      />
    </ThemeProvider>
  );
};

export default Queue;
